<div>
  @if (isLoggedIn) {
    <sae-secure-global-header  [stories]="$safeNavigationMigration(landingData?.stories)"></sae-secure-global-header>
  }
  @if (isLoggedIn) {
    <div class="header-padding">
      <fwc-header-page >
        <app-search-header  [searchOptions]="$safeNavigationMigration(landingData?.stories)"></app-search-header>
      </fwc-header-page>
    </div>
  }
  <router-outlet></router-outlet>
  <sae-global-footer  [stories]="$safeNavigationMigration(landingData?.stories)"></sae-global-footer>
</div>

<fwc-modal id="timeOutModal" text-header="Session TimeOut" attr.text-body="{{modalMsg}}">
  <div slot="actions">
    <button class="fwc-btn fwc-btn-secondary" id="btnClose" (click)="logout()">End Session</button>
    <button class="fwc-btn fwc-btn-primary" id="btnApply" (click)="stay()">Continue Session</button>
  </div>
</fwc-modal>

@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}


